/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``medal-first.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const MedalFirstIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule=""
        d="M8.19333 15.3333C6.91333 15.3333 5.63333 14.8467 4.66 13.8733C2.9 12.1133 2.72667 9.35334 4.15334 7.4L1.83334 3.24667C1.48667 2.62 1.29334 2.27334 1.34 1.84667C1.38667 1.47334 1.58 1.14 1.88667 0.920004C2.23334 0.66667 2.63334 0.66667 3.34667 0.66667H4.83333C5.1 0.66667 5.27333 0.66667 5.47333 0.733337C5.65334 0.793337 5.81333 0.880004 5.95333 1.00667C6.10667 1.14667 6.2 1.29334 6.33333 1.52667L8.2 4.69334L10.06 1.52C10.1933 1.29334 10.28 1.14 10.44 1C10.5733 0.880004 10.74 0.78667 10.9133 0.72667C11.1133 0.660004 11.2867 0.660004 11.5533 0.660004H13.0467C13.7667 0.660004 14.16 0.660004 14.5067 0.913337C14.8133 1.13334 15.0067 1.47334 15.0533 1.84C15.1 2.26667 14.9133 2.61334 14.56 3.24L12.24 7.38667C13.66 9.34 13.4933 12.1 11.7333 13.86C10.76 14.8333 9.48 15.32 8.2 15.32L8.19333 15.3333ZM5.44 7.91334C4.17334 9.35334 4.22667 11.5533 5.6 12.9267C7.02667 14.3533 9.35333 14.3533 10.7867 12.9267C12.16 11.5533 12.2133 9.35334 10.9467 7.91334C10.9467 7.90667 10.9333 7.9 10.9267 7.89334C10.88 7.84 10.8333 7.79334 10.7867 7.74C9.35333 6.31334 7.03334 6.31334 5.6 7.74C5.55334 7.78667 5.50667 7.84 5.46 7.89334C5.46 7.9 5.44667 7.90667 5.44 7.91334ZM9.28667 5.45334C9.99333 5.61334 10.6733 5.92 11.2667 6.38667L13.3867 2.59334C13.5133 2.37334 13.64 2.14 13.6933 2.01334C13.5533 2 13.2933 2 13.0333 2H11.54C11.4267 2 11.3533 2 11.2933 2C11.2933 2.02667 11.26 2.09334 11.2 2.18667L9.28 5.44667L9.28667 5.45334ZM2.69334 2.01334C2.74667 2.14 2.87334 2.37334 3 2.59334L5.12 6.38667C5.71334 5.92 6.39333 5.60667 7.1 5.45334L5.18 2.2C5.12 2.1 5.08667 2.03334 5.05333 1.98667C5.02667 1.99334 4.95334 2 4.84 2H3.34667C3.09334 2 2.82667 2 2.68667 2.01334H2.69334ZM9.03333 12.6667H7.36667C7 12.6667 6.7 12.3667 6.7 12C6.7 11.6333 7 11.3333 7.36667 11.3333H7.53334V9.91334C7.23334 10.0867 6.84 10 6.64667 9.70667C6.44 9.4 6.52667 8.98667 6.83333 8.78L7.83333 8.11334C8.04 7.98 8.3 7.96667 8.52 8.08C8.74 8.19334 8.87333 8.42 8.87333 8.66667V11.3333H9.04C9.40667 11.3333 9.70667 11.6333 9.70667 12C9.70667 12.3667 9.40667 12.6667 9.04 12.6667H9.03333Z"
        transform=""
      />
    </g>
  </svg>
);

MedalFirstIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

MedalFirstIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

MedalFirstIcon.displayName = "MedalFirstIcon";

export default MedalFirstIcon;
